import { render } from "./ManagerDashboard.vue?vue&type=template&id=0d55f17c&scoped=true"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=0d55f17c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d55f17c"]])

export default __exports__